import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, Theme } from '@mui/material/styles';
import React, { PropsWithChildren } from 'react';

export const Page = ({
  children,
  muiTheme,
}: PropsWithChildren<{
  printMode?: boolean;
  muiTheme: Partial<Theme>;
}>) => {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
